import { useEffect, useState } from 'react'

export type IconOption = { name: string; filename: string }

export const useIconOptions = (): IconOption[] => {
  const [iconOptions, setIconOptions] = useState<IconOption[]>([])

  useEffect(() => {
    fetch('/data/dataset_icons.csv')
      .then((r) => r.text())
      .then((text) => {
        const options = text
          .trim()
          .split('\n')
          .slice(1)
          .filter((line) => line.endsWith('.svg'))
          .map((line) => {
            const [name, filename] = line.split(',')
            return { name, filename }
          })
        setIconOptions(options)
      })
      .catch((err) => console.error('Failed to load icon options:', err))
  }, [])

  return iconOptions
}
